import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  const bullets = ['Más de 100 recetas', 'Ingredientes accesibles', 'Bonus exclusivos incluidos', 'Descarga inmediata', 'Garantía de 7 días'];
  return <section className="relative pt-8 pb-10 md:pt-14 md:pb-16 px-6 overflow-hidden" data-id="element-71">
      <div className="max-w-3xl mx-auto text-center" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-73">
          {/* Etiqueta superior */}
          <span className="inline-block py-1 px-3 rounded-full bg-green-100 text-primary font-semibold text-xs tracking-wide uppercase mb-4" data-id="element-74">
            Enciclopedia Gluko Libre Argentina
          </span>

          {/* Título */}
          <h1 className="font-serif font-black text-gray-900 leading-[1.05] tracking-tight text-4xl sm:text-5xl md:text-6xl mb-3" data-id="element-75">
            VOLVÉ A DISFRUTAR LAS{' '}
            <span className="text-primary" data-id="element-76">COMIDAS QUE MÁS TE GUSTAN</span>
          </h1>

          {/* Subtítulo principal destacado */}
          <p className="font-serif text-xl sm:text-2xl md:text-3xl text-gray-800 leading-snug mb-4" data-id="element-77">
            Aunque tengas{' '}
            <span className="text-primary font-semibold" data-id="element-78">
              diabetes, prediabetes o resistencia a la insulina
            </span>
            .
          </p>

          {/* Texto descriptivo */}
          <p className="text-base sm:text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto mb-6" data-id="element-79">
            Más de{' '}
            <span className="text-primary font-semibold" data-id="element-80">100 recetas</span>{' '}
            inspiradas en panes, empanadas, pizzas, postres y muchas de las
            comidas que más nos gustan a los argentinos. Todo explicado{' '}
            <span className="text-gray-900 font-semibold" data-id="element-81">paso a paso</span> y
            utilizando ingredientes{' '}
            <span className="text-accent font-semibold" data-id="element-82">
              fáciles de conseguir
            </span>
            .
          </p>
        </motion.div>

        {/* Imagen principal del producto — grande y centrada, antes del CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-sm sm:max-w-md mb-6" data-id="element-83">
          <div className="absolute -inset-5 bg-green-100/60 rounded-[2.5rem] blur-2xl -z-10" data-id="element-84" />
          <img src="https://cdn.magicpatterns.com/uploads/b4BQKUnCQpZ48J6KjWDaFM/ChatGPT_Image_19_jun_2026,_03_05_32.png" alt="Portada de la Enciclopedia Gluko Libre Argentina" className="w-full rounded-2xl shadow-2xl ring-1 ring-black/5" data-id="element-85" />
        </motion.div>

        {/* Botón CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.35
      }} className="flex flex-col items-center" data-id="element-86">
          <Button className="w-full sm:w-auto text-xl px-10 py-6 shadow-xl shadow-primary/20" data-id="element-87">
            QUIERO ACCEDER AHORA
          </Button>

          {/* Bullets compactos como mini prueba social */}
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mt-4" data-id="element-88">
            {bullets.map((bullet, index) => <span key={index} className="inline-flex items-center gap-1.5 text-sm text-gray-600 font-medium" data-id="element-89">
                <CheckCircle2 className="w-4 h-4 text-accent flex-shrink-0" data-id="element-90" />
                {bullet}
              </span>)}
          </div>
        </motion.div>
      </div>
    </section>;
}